'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

require('./view.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var SearchField = (_temp = _class = function (_Field) {
  _inherits(SearchField, _Field);

  function SearchField(props) {
    _classCallCheck(this, SearchField);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _this.state = {
      value: _this.getSearchValue()
    };
    return _this;
  }

  SearchField.prototype.componentDidMount = function componentDidMount() {
    _Field.prototype.componentDidMount.call(this);
    this.setState({
      value: this.getSearchValue()
    });
  };

  SearchField.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    typeof _Field.prototype.componentDidUpdate === 'function' && _Field.prototype.componentDidUpdate.call(this, prevProps, prevState);
    var value = this.getSearchValue();
    if (this.state.value !== value) {
      this.setState({ value: value });
    }
  };

  SearchField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-search-input'
    });
  };

  // 匹配输入值中与DataSource中的value，若相等则展示DataSource中的label，否则原始value展示


  SearchField.prototype.getSearchValue = function getSearchValue(dataSource, val) {
    dataSource = dataSource || this.getOptions(true);
    var value = val || this.getValue() || '';
    for (var i = 0, len = (dataSource || []).length; i < len; i++) {
      if (dataSource[i] && dataSource[i].value === value) {
        value = dataSource[i].label || value;
        break;
      }
    }
    return value;
  };

  SearchField.prototype.renderControl = function renderControl() {
    var _this2 = this;

    var commonProps = this.getControlProps();
    var options = this.getOptions(true);

    var searchProps = _extends({}, commonProps, {
      size: 'medium',
      hasIcon: false,
      shape: 'simple',
      dataSource: options,
      style: { width: '100%' }
    });

    // 为了让DataSource中选中的值在SearchInput中展示对应的label，对SearchInput组件做了展示上的特殊处理，执行渲染引擎onChange方法则保持之前的值不变
    var originOnChange = searchProps.onChange;

    searchProps.onChange = function (val) {
      _this2.setState({ value: _this2.getSearchValue(options, val) });
      originOnChange(val);
    };

    return _react2.default.createElement(_next.Search, _extends({}, searchProps, { value: this.state.value }));
  };

  return SearchField;
}(_vuFusionField2.default), _class.displayName = 'SearchInput', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  fieldId: null,
  hasClear: true
}), _class.propTypes = {
  fieldId: _propTypes2.default.string,
  label: _propTypes2.default.string
}, _temp);
exports.default = SearchField;
module.exports = exports['default'];